import { connect } from 'react-redux'
import { approveIdeaById } from 'services/ideas'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import ApproveView from './ApproveView'

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.id,
  approvedReasons: ownProps.approvedReasons,
  customIdeaTitles: state.data.domain.customTitlesConf.customIdeaTitles
})

const mapDispatchToProps = dispatch => {
  return {
    onClick: (id, reason, returnInvestment) => {
      const onSuccess = () => {
        window.location.reload()
      }
      dispatch(hideDialog())
      dispatch(approveIdeaById(id, reason, returnInvestment, onSuccess))
    },
    cancelButtonAction: () => dispatch(hideDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApproveView)
